var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"facebook","d":"M15.24,2.54a12.7,12.7,0,1,1-12.7,12.7A12.7,12.7,0,0,1,15.24,2.54Zm0-2.54A15.24,15.24,0,1,0,30.48,15.24,15.24,15.24,0,0,0,15.24,0ZM12.7,12.7H10.16v2.54H12.7v7.62h3.81V15.24h2.31l.23-2.54H16.51V11.64c0-.6.12-.84.71-.84h1.83V7.62H16c-2.28,0-3.3,1-3.3,2.93Z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 30.48 30.48"};

module.exports = Facebook;

Facebook.default = Facebook;
